module.exports = __webpack_public_path__ + "img/tpc-web-8.affb5fee.webp";